var customerTypes = [
  { "name": "Real", "label": "حقیقی", value: 0 },
  { "name": "Legal", "label": "حقوقی", value: 1 },
];

export default customerTypes;